import ContactSection from '../../components/landing-pages-v2/ContactSection';
import FCContactUs from '../../components/landing-pages-v2/FCContactUs';
import FCHero from '../../components/landing-pages-v2/FCHero';
import FCMap from '../../components/landing-pages-v2/FCMap';
import FCMissionStatement from '../../components/landing-pages-v2/FCMissionStatement';
import FCProductOptions from '../../components/landing-pages-v2/FCProductOptions';
import FCTestimonialCarousel from '../../components/landing-pages-v2/FCTestimonialCarousel';
import FCThreeSteps from '../../components/landing-pages-v2/FCThreeSteps';
import FCTrustBanner from '../../components/landing-pages-v2/FCTrustBanner';
import FCValueTracker from '../../components/landing-pages-v2/FCValueTracker';
import HeroV2 from '../../components/landing-pages-v2/HeroV2';
import HeroV2WithMarkers from '../../components/landing-pages-v2/HeroV2WithMarkers';
import LWCHeroCard from '../../components/landing-pages-v2/LWCHeroCard';
import LWCImageCard from '../../components/landing-pages-v2/LWCImageCard';
import LWCTextSection from '../../components/landing-pages-v2/LWCTextSection';
import MapBackgroundHero from '../../components/landing-pages-v2/MapBackgroundHero';
import PhotoTestimonials from '../../components/landing-pages-v2/PhotoTestimonials';
import Spacer from '../../components/landing-pages-v2/Spacer';
import StandaloneText from '../../components/landing-pages-v2/StandaloneText';
import { dynamicEntry } from './dynamicEntry';
import type IEntryLookup from './entries';

// CarouselCards swaps mobile/desktop subtrees via useMedia, so it stays client-only.
const CarouselCards = dynamicEntry(
  () => import('../../components/landing-pages-v2/CarouselSection/CarouselCards'),
);
// Browser-only iframe runtime stays client-only.
const SuperIframe = dynamicEntry(() => import('../../components/landing-pages-v2/SuperIframe'));
const TextBanner = dynamicEntry(() => import('../../components/landing-pages-v2/TextBanner'));

const homePageV2EntryLookup: IEntryLookup = {
  // only including blocks used in https://app.contentful.com/spaces/bjlp9d7o6h1o/entries/3jH3XGe228kfdp8fBGddyW?focusedField=slug
  // for performance
  block: {
    lpComponentMapBackgroundHero: MapBackgroundHero,
    lpComponentCarouselCards: CarouselCards,
    lpComponentContactSection: ContactSection,
    lpComponentLwcTextSection: LWCTextSection,
    lpComponentLwcHeroCard: LWCHeroCard,
    lpComponentLwcImageCard: LWCImageCard,
    lpComponentHeroV2: HeroV2,
    lpComponentHeroV2WithMarkers: HeroV2WithMarkers,
    lpComponentSpacer: Spacer,
    lpComponentStandaloneText: StandaloneText,
    fcHero: FCHero,
    fcTrustBanner: FCTrustBanner,
    fcValueTracker: FCValueTracker,
    fcThreeSteps: FCThreeSteps,
    fcProductOptions: FCProductOptions,
    fcTestimonialCarousel: FCTestimonialCarousel,
    fcMap: FCMap,
    fcMissionStatement: FCMissionStatement,
    fcContactUs: FCContactUs,
    lpComponentTextBanner: TextBanner,
    lpComponentPhotoTestimonials: PhotoTestimonials,
    componentSuperIframe: SuperIframe,
  },
  inline: {},
};

export default homePageV2EntryLookup;
